import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { t } from 'ttag';

import loadTranslations from 'js/localeSetup';
import client from '../utils/client';

import 'lazysizes';

import './category-bar.less';

let categoryTitle = t`Popular Categories`;

class PopularCategories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      elements: []
    };
  }

  componentDidMount() {
    this.getItems();
  }

  getItems = () => {
    const mainElement = document.querySelector('.categories-bar');
    if (this.props.endpoint) {
      client.get(this.props.endpoint).then(res => {
        this.setState({
          elements: res.data['category_-_top_banner']
        });
      });
    } else if (mainElement) {
      categoryTitle = mainElement.dataset.title;
      this.setState({
        elements: JSON.parse(mainElement.dataset.items)['category_-_top_banner']
      });
    }
  };

  render() {
    const categoryStyles = ['popular-categories'];
    if (this.props.embedded)
      categoryStyles.push('popular-categories--embedded');
    return (
      <div className={categoryStyles.join(' ')}>
        <h2>{categoryTitle}</h2>
        <ul>
          {this.state.elements.length > 0 &&
            this.state.elements.map((el, i) => {
              return (
                <li
                  className="category-item"
                  key={el.headline}
                  data-cro-tracking={`track-index_tiny-category-${i + 1}`}
                >
                  <a className="category-box" href={el.link}>
                    <img
                      data-src={el.icon}
                      alt={el.headline}
                      className="lazyload"
                    />
                    <div className="inner-text">
                      {`${el.headline} `}
                      <span className="link-text">&gt;</span>
                    </div>
                  </a>
                </li>
              );
            })}
        </ul>
      </div>
    );
  }
}

(async () => {
  const rootElement = document.getElementById('popularCategories');
  await loadTranslations();

  if (rootElement) {
    ReactDOM.render(<PopularCategories />, rootElement);
  }
})();

export default PopularCategories;
